import React from 'react';
import PropTypes from 'prop-types';
import { Spacing } from '@reservamos/elements';
import 'styles/components/ExchangeLayout';
import Header from 'components/Header';
import BrandLogo from 'components/BrandLogo';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useWhitelabelFeatures from 'hooks/whitelabel/useWhitelabelFeatures';

/**
 * ExchangeLayout Functional Component
 *
 * A layout component that renders a sidebar alongside the main content.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The main content to be displayed in the layout.
 * @param {React.ReactNode} props.sidebar - The sidebar content to be displayed alongside the main content.
 *
 * @returns {JSX.Element} The rendered layout component with the sidebar and main content.
 */
const ExchangeLayout = ({ children, sidebar }) => {
  const location = useLocation();
  const features = useWhitelabelFeatures();
  // TODO: This is a temporary solution to hide the sidebar when the enhanced ticket data is enabled.
  // Petition made by client (CDS) to hide the sidebar
  const showEnhancedTicketData = features.SHOW_ENHANCED_TICKET_DATA;

  return (
    <div className="l-exchange">
      <Header isFixed>
        <BrandLogo />
      </Header>
      <div className="exchange-container">
        <div className="exchange-content">
          <Spacing vertical size="XL">
            {children}
          </Spacing>
        </div>
        {!location.pathname.includes('ticket-list') && !showEnhancedTicketData && (
          <div className="exchange-sidebar">
            <div className="exchange-sidebar-wrapper">{sidebar}</div>
          </div>
        )}
      </div>
    </div>
  );
};

ExchangeLayout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.node.isRequired,
};

export default ExchangeLayout;
